/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { Button, Col, Form, Input, Row, Skeleton, Spin } from 'antd';
import Sider from 'antd/es/layout/Sider';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axiosInstance from '../../../../axios_instance';
import {
  IsAdminContext,
  ProfilePictureContext,
  UserDesignationDataContext,
  UserProfileDataContext,
} from '../../../../context';
import { errorHandling } from '../../../../utils/helper';
import ResumeUpload from '../../../general/file-upload/resume-upload';
import { SelectStringInput } from '../../../general/select-input';
import Resume from '../../../uicontainers/user/Resume';
import ProfilePicture from '../../../uicontainers/user/profile-picture';
import styles from './styles.module.scss';

const StyledSelectStringInput = styled(SelectStringInput)`
  .ant-select-selector {
    background-color: #f6f7fc !important;
    border: none !important;
  }
  border-bottom: 1px solid #d5d5d5;
`;
const StyledInput = styled(Input)`
  ::-webkit-calendar-picker-indicator {
    content: url(/calendar_today.png);
    background: #f6f7fc;
    margin-right: -4px;
  }
`;
const StyledSider = styled(Sider)`
  background: white !important;
  word-break: break-word !important;
  position: fixed !important;
  top: 98px !important;
  @media (max-width: 800px) {
    background: white !important;
    word-break: break-word !important;
    position: absolute !important;
    top: 98px !important;
    overflow: auto;
  }
  overflow: auto;
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    // box-shadow: inset 0 0 5px grey;
    border: none;
    border-radius: 15px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 15px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5);
  }
`;
//component for left panel in detail view of a user profile
const LeftPanel: React.FC = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { userProfileData, setUserProfileData } = useContext(
    UserProfileDataContext
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { userDesignationData, setUserDesignationData } = useContext(
    UserDesignationDataContext
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { userProfilePictureData, setUserProfilePictureData } = useContext(
    ProfilePictureContext
  );
  //store available designation names from database.user can select designation from this list.
  const [designationList, setDesignationList] = useState<{
    [key: string]: number;
  }>({ key: 1 });
  const [genderValue, setGenderValue] = useState<number>();
  const [designationValue, setDesignationValue] = useState<number>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const isAdmin = useContext(IsAdminContext);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const navigation = useNavigate();

  const memoizedUserProfileData = useMemo(
    () => userProfileData,
    [userProfileData]
  );
  const memoizedUserDesignationData = useMemo(
    () => userDesignationData,
    [userDesignationData]
  );
  //for responsiveness.if windows is small panel will be collapsible.
  // const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  //edited data state will be filled up by existing profile data first.in javascript if we compare null values with a value.it will return false.for this reason we made sure that edited value wont be null.
  useEffect(() => {
    setGenderValue(userProfileData['personal_details']['gender']['id']);
    setDesignationValue(userDesignationData['designation']['designation_id']);
    setEditedData({
      address: userProfileData['personal_details']['address'],
      name: userProfileData['personal_details']['name'],
      professional_link:
        userProfileData['personal_details']['professional_link'],
      mobile: userProfileData['personal_details']['mobile'],
      gender: userProfileData['personal_details']['gender']['id'],
      designation_id: userDesignationData['designation']['designation_id'],
      date_of_birth:
        userProfileData['personal_details']['date_of_birth'].toString(),
      date_of_last_skill_matrix_session:
        userProfileData['date_of_last_skill_matrix_session'],
    });
  }, [memoizedUserProfileData, memoizedUserDesignationData]);

  useEffect(() => {
    axiosInstance
      .get('/api/v1/designations')
      .then((response) => {
        const designationList = response.data.reduce(
          (
            initialList: Object,
            CurrentList: { [key: string]: number | string }
          ) => ({
            ...initialList,
            [CurrentList.designation]: CurrentList.designation_id,
          }),
          {}
        );
        console.log(designationList);
        setDesignationList(designationList);
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
      .catch((error) => {});
  }, []);

  const handleChange = (e: any) => {
    setEditedData({
      ...editedData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const updateData = (e: any) => {
    const requestBody: { [key: string]: any } = {};
    let isUpdated = false;
    requestBody['profile_id'] = userProfileData['id'];
    //comparing edited data is different than old data.if they are different, api will be called.
    if (
      editedData['address'] !== userProfileData['personal_details']['address']
    ) {
      requestBody['address'] = editedData['address'];
      isUpdated = true;
    }
    if (editedData['name'] !== userProfileData['personal_details']['name']) {
      requestBody['name'] = editedData['name'];
      isUpdated = true;
    }
    if (
      editedData['professional_link'] !==
      userProfileData['personal_details']['professional_link']
    ) {
      requestBody['professional_link'] = editedData['professional_link'];
      isUpdated = true;
    }
    if (
      editedData['tagline'] !== userProfileData['personal_details']['tagline']
    ) {
      requestBody['tagline'] = editedData['tagline'];
      isUpdated = true;
    }
    if (editedData['about'] !== userProfileData['personal_details']['about']) {
      requestBody['about'] = editedData['about'];
      isUpdated = true;
    }
    if (
      editedData['mobile'] !== userProfileData['personal_details']['mobile']
    ) {
      requestBody['mobile'] = editedData['mobile'];
      isUpdated = true;
    }
    if (
      editedData['date_of_birth'] !==
      userProfileData['personal_details']['date_of_birth'].toString()
    ) {
      requestBody['date_of_birth'] = editedData['date_of_birth'];
      isUpdated = true;
    }
    if (genderValue !== userProfileData['personal_details']['gender']['id']) {
      requestBody['gender'] = genderValue;
      isUpdated = true;
    }
    if (
      designationValue !== userDesignationData['designation']['designation_id']
    ) {
      requestBody['designation_id'] = designationValue;
      isUpdated = true;
    }
    if (
      editedData['date_of_last_skill_matrix_session'] !==
      userProfileData['date_of_last_skill_matrix_session']
    ) {
      requestBody['date_of_last_skill_matrix_session'] =
        editedData['date_of_last_skill_matrix_session'] === ''
          ? null
          : editedData['date_of_last_skill_matrix_session'];
      isUpdated = true;
      // setUserProfileData()
    }
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/user-profiles/';
    } else {
      url = '/api/v1/profile/user-profiles/';
    }
    if (isUpdated) {
      axiosInstance
        .post(url, requestBody)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then((response) => {
          setIsEdit(false);
          setErrorMessage({});
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          errorHandling(error, setErrorMessage);
        })
        .finally(() => {
          setIsSubmitted(false);
        });
    } else {
      setIsEdit(false);
    }
  };

  const [showFullText, setShowFullText] = useState(false);

  const toggleFullText = () => {
    setShowFullText(!showFullText);
  };

  return (
    <StyledSider
      className={styles.container}
      width={'330px'}
      // breakpoint="md"
      // collapsedWidth="0"
      // onCollapse={(collapsed, type) => {
      //   if (type === 'clickTrigger') {
      //     setIsCollapsed(collapsed);
      //   }
      // }}
    >
      {userProfileData['email'] === '' ? (
        <>
          <p>Loading...</p>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />{' '}
        </>
      ) : (
        <>
          <Row style={{ position: 'relative' }}>
            <Button
              type="text"
              style={{
                position: 'absolute',
                right: '5px',
                border: 'hidden',
                textDecoration: 'blue',
              }}
              onClick={() => {
                setIsEdit(true);
              }}
            >
              <img src="/edit.png" />
            </Button>
          </Row>
          <div>
            {/* NOTE: Need To be Updated */}
            {/* <img className={styles["profile-picture"]} src={userProfilePictureData} style={{cursor:"pointer"}}/> */}
            <ProfilePicture
              {...{ userProfilePictureData: userProfilePictureData }}
            />
            {isAdmin === '1' && (
              <p
                style={{ cursor: 'pointer', color: '#005e8c' }}
                onClick={() =>
                  navigation(`/admin/resume/${userProfileData['id']}`)
                }
              >
                View Resume
              </p>
            )}
            {isAdmin === '0' && (
              <p
                style={{ cursor: 'pointer', color: '#005e8c' }}
                onClick={() =>
                  navigation(`/employee-resume/${userProfileData['id']}`)
                }
              >
                View Resume
              </p>
            )}

            {isEdit ? (
              <Row className={styles.row}>
                <Col className={styles.col} span={8}>
                  <p className={styles.title}>Name : </p>
                </Col>

                <Col className={styles.col} span={16}>
                  <Input
                    className={styles.input}
                    onChange={handleChange}
                    name="name"
                    defaultValue={userProfileData['personal_details']['name']}
                  />
                </Col>
                <br />
              </Row>
            ) : (
              <h1 className={styles['profile-name']}>
                {userProfileData['personal_details']['name']}
              </h1>
            )}

            {isEdit ? (
              <Row className={styles.row}>
                <Col className={styles.col} span={8}>
                  <p className={styles.title}>Designation : </p>
                </Col>
                <Col className={styles.col} span={16}>
                  <StyledSelectStringInput
                    {...{
                      optionList: designationList,
                      width: 200,
                      placeHolder: 'Select Designation',
                      setValue: setDesignationValue,
                      defaultValue: designationValue,
                    }}
                  />
                </Col>
              </Row>
            ) : (
              <p className={styles.designation}>
                {userDesignationData['designation']['designation']}
              </p>
            )}

            {isEdit ? (
              <Row className={`${styles.row} mb-2`}>
                <Col className={styles.col} span={8}>
                  <p className={styles.title}>Tagline : </p>
                </Col>
                <Col className={styles.col} span={16}>
                  <Form.Item>
                    <Input
                      className={styles.input}
                      onChange={handleChange}
                      name="tagline"
                      style={{
                        borderBottom:
                          'tagline' in errorMessage ? '1px solid red' : '',
                      }}
                      defaultValue={
                        userProfileData['personal_details']['tagline']
                      }
                    />
                    <Row>
                      <p style={{ color: 'red' }}>
                        {'tagline' in errorMessage
                          ? errorMessage['tagline']
                          : ''}
                      </p>
                    </Row>
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <p style={{ textAlign: 'center' }}>
                {userProfileData['personal_details']['tagline']}
              </p>
            )}

            {isEdit ? (
              <Row className={`${styles.row} mb-2`}>
                <Col className={styles.col} span={8}>
                  <p className={styles.title}>About : </p>
                </Col>
                <Col className={styles.col} span={16}>
                  <Form.Item>
                    <Input.TextArea
                      defaultValue={
                        userProfileData['personal_details']['about']
                      }
                      name="about"
                      placeholder="About"
                      onChange={handleChange}
                    />
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <p>
                  {showFullText ? (
                    userProfileData['personal_details']['about']
                  ) : (
                    <>
                      {userProfileData['personal_details']['about'] &&
                        (userProfileData['personal_details']['about'].length >
                        120 ? (
                          <>
                            {userProfileData['personal_details'][
                              'about'
                            ].substring(0, 120)}
                            <span>...</span>
                          </>
                        ) : (
                          userProfileData['personal_details']['about']
                        ))}
                    </>
                  )}
                  {userProfileData['personal_details']['about'] &&
                    userProfileData['personal_details']['about'].length >
                      120 && (
                      <a href="#" onClick={toggleFullText}>
                        {showFullText ? ' See less' : ' See more'}
                      </a>
                    )}
                </p>
              </div>
            )}
            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Experience : </p>
              </Col>

              <Col className={styles.col} span={16}>
                <p className={styles.value}>
                  {userProfileData['personal_details']['experience_year'] +
                    ' years ' +
                    userProfileData['personal_details']['experience_month'] +
                    ' months'}
                </p>
              </Col>
              <br />
            </Row>
            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Profession Link : </p>
              </Col>

              <Col className={styles.col} span={16}>
                {isEdit ? (
                  <Input
                    className={styles.input}
                    onChange={handleChange}
                    name="professional_link"
                    defaultValue={
                      userProfileData['personal_details']['professional_link']
                    }
                  />
                ) : (
                  <p className={styles.value}>
                    {userProfileData['personal_details']['professional_link']}
                  </p>
                )}
              </Col>
              <br />
            </Row>

            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Phone : </p>
              </Col>

              <Col className={styles.col} span={16}>
                {isEdit ? (
                  <Input
                    className={styles.input}
                    onChange={handleChange}
                    name="mobile"
                    defaultValue={userProfileData['personal_details']['mobile']}
                  />
                ) : (
                  <p className={styles.value}>
                    {userProfileData['personal_details']['mobile']}
                  </p>
                )}
              </Col>
              <br />
            </Row>
            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Email :</p>
              </Col>
              <Col className={styles.col} span={16}>
                {' '}
                <p className={styles.value}>{userProfileData['email']}</p>
                <br />
              </Col>
            </Row>
            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Date of Birth :</p>
              </Col>
              <Col className={styles.col} span={16}>
                {isEdit ? (
                  <>
                    <StyledInput
                      className={styles.input}
                      onChange={handleChange}
                      type="date"
                      name="date_of_birth"
                      style={{
                        borderBottom:
                          'date_of_birth' in errorMessage
                            ? '1px solid red'
                            : '',
                      }}
                      defaultValue={
                        userProfileData['personal_details']['date_of_birth']
                      }
                    />
                    <Row>
                      <p style={{ color: 'red' }}>
                        {'date_of_birth' in errorMessage
                          ? errorMessage['date_of_birth']
                          : ''}
                      </p>
                    </Row>
                  </>
                ) : (
                  <p className={styles.value}>
                    {userProfileData['personal_details'][
                      'date_of_birth'
                    ].toString()}
                  </p>
                )}
              </Col>
              <br />
            </Row>
            {/* <Row className={styles.row}>
                <Col className={styles.col} span={8}>
                  <p className={styles.title}>Gender : </p>
                </Col>
                <Col className={styles.col} span={16}>
                  {' '}
                  {isEdit ? (
                    <StyledSelectStringInput
                      {...{
                        optionList: { Male: 1, Female: 2, Other: 3 },
                        width: 200,
                        placeHolder: 'Select Gender',
                        setValue: setGenderValue,
                        defaultValue: genderValue,
                      }}
                    />
                  ) : (
                    <p className={styles.value}>
                      {userProfileData['personal_details']['gender']['name']}
                    </p>
                  )}
                </Col>
                <br />
              </Row> */}
            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Address : </p>
              </Col>
              <Col className={styles.col} span={16}>
                {isEdit ? (
                  <>
                    <Input
                      className={styles.input}
                      onChange={handleChange}
                      name="address"
                      style={{
                        borderBottom:
                          'address' in errorMessage ? '1px solid red' : '',
                      }}
                      defaultValue={
                        userProfileData['personal_details']['address']
                      }
                    />
                    <Row>
                      <p style={{ color: 'red' }}>
                        {'address' in errorMessage
                          ? errorMessage['address']
                          : ''}
                      </p>
                    </Row>
                  </>
                ) : (
                  <p className={styles.value}>
                    {userProfileData['personal_details']['address']}
                  </p>
                )}
              </Col>
              <br />
            </Row>
            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Skill Matrix Session :</p>
              </Col>
              <Col className={styles.col} span={16}>
                {isEdit ? (
                  <>
                    <StyledInput
                      className={styles.input}
                      disabled={isAdmin === '1' ? false : true}
                      onChange={handleChange}
                      type="date"
                      name="date_of_last_skill_matrix_session"
                      style={{
                        borderBottom:
                          'date_of_last_skill_matrix_session' in errorMessage
                            ? '1px solid red'
                            : '',
                      }}
                      defaultValue={
                        userProfileData['date_of_last_skill_matrix_session']
                      }
                    />
                    <Row>
                      <p style={{ color: 'red' }}>
                        {'date_of_last_skill_matrix_session' in errorMessage
                          ? errorMessage['date_of_last_skill_matrix_session']
                          : ''}
                      </p>
                    </Row>
                  </>
                ) : (
                  <p className={styles.value}>
                    {userProfileData['date_of_last_skill_matrix_session'] &&
                      userProfileData[
                        'date_of_last_skill_matrix_session'
                      ].toString()}
                  </p>
                )}
              </Col>
              <br />
            </Row>
            {isEdit ? (
              <>
                {isSubmitted ? (
                  <Spin></Spin>
                ) : (
                  <Row>
                    <Button
                      className={styles['save-button']}
                      style={{
                        float: 'right',
                        marginLeft: 'auto',
                        marginRight: '0px',
                      }}
                      onClick={updateData}
                    >
                      Save
                    </Button>
                    <Button
                      className={styles['cancel-button']}
                      style={{ marginRight: '0px' }}
                      // eslint-disable-next-line @typescript-eslint/no-unused-vars
                      onClick={(e) => {
                        setIsEdit(false);
                        setErrorMessage({});
                      }}
                    >
                      Cancel
                    </Button>
                  </Row>
                )}
              </>
            ) : (
              <></>
            )}
            <Row className={styles.row}>
              <Col className={styles.col} span={8}>
                <p className={styles.title}>Resume : </p>
              </Col>
              <Col className={styles.col} span={16}>
                <Row>
                  {userProfileData['personal_details']['cv_urls'].map(
                    (resume: any, index: number) => {
                      return <Resume {...resume} key={index} />;
                    }
                  )}
                </Row>
                <ResumeUpload />
              </Col>
              <br />
            </Row>
          </div>
        </>
      )}
    </StyledSider>
  );
};

export default LeftPanel;
